import { type AvatarProps, SelectComponents } from '@frontend/components';

import { UNASSIGNED_VALUE } from 'modules/common/smartComponents/const';

import { ANYBODY_VALUE } from '../const';
import { CustomAvatar } from './CustomAvatar';

export const Control = ({ children, ...restProps }) => {
  const avatarProps: AvatarProps = {};

  if (!restProps.selectProps.inputValue.trim()) {
    const selectValue = restProps.getValue();
    const { avatarColor, value, label, isDeleted } =
      (Array.isArray(selectValue) ? selectValue[0] : selectValue) ?? {};

    avatarProps.backgroundColor = !isDeleted ? avatarColor : undefined;
    avatarProps.name =
      value !== UNASSIGNED_VALUE && value !== ANYBODY_VALUE && !isDeleted
        ? label
        : undefined;
  }

  return (
    <SelectComponents.Control {...restProps}>
      {!restProps.isMulti ? (
        <CustomAvatar {...avatarProps} marginLeft={1} />
      ) : null}
      {children}
    </SelectComponents.Control>
  );
};
